var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`inline-block w-6 h-6 rounded-full animate-spin border-4 border-solid border-${_vm.color} border-t-transparent`})
}
var staticRenderFns = []

export { render, staticRenderFns }